import { customAlphabet } from 'nanoid';

const webLicensePlatePrefix = 'W';
// spellchecker: ignore ABCDEFGHJKLMNPQRSTUVWXYZ
export const LICENSE_PLATE_ALPHA_NUMERIC = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';

const generateLicensePlateCore = customAlphabet(LICENSE_PLATE_ALPHA_NUMERIC, 6);
export const generateLicensePlate = () =>
  webLicensePlatePrefix + generateLicensePlateCore();
